import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MessageDialog from "../../components/MessageDialog";
import StorageService from "../../services/StorageService";
import ProjectCategoryService from "../../services/ProjectCategoryService";
import ProjectService from "../../services/ProjectService";
import StoreService from "../../services/StoreService";
import LocationService from "../../services/LocationService";
import MaterialReconciliationReportService from "../../services/materialReconciliationReportService";
import utility from "../../utils/utility";
import XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo } from "../../utils/pdfLogo";
import ProjectStoreService from "../../services/ProjectStoreService";
import ProjectLocationService from "../../services/ProjectLocationService";

export default function MaterialReconciliationReport() {
    const activeCompany = StorageService.activeCompany();
    const companyId = activeCompany?.companyId || "";
    const [projectCategoryId, setProjectCategoryId] = useState("");
    const [projectId, setProjectId] = useState("");
    const [storeId, setStoreId] = useState("");
    const [locationId, setLocationId] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [projectCategories, setProjectCategories] = useState([]);
    const [projects, setProjects] = useState([]);
    const [stores, setStores] = useState([]);
    const [locations, setLocations] = useState([]);

    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("");

    // ✅ PAGINATION STATES
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);



    // const filteredProjects = projects;

    // const selectedCategory = projectCategories.find(
    //     (cat) => String(cat.id) === String(projectCategoryId)
    // );

    // const selectedCategoryCode = selectedCategory?.categoryCode;

    // const filteredProjects = selectedCategoryCode
    //     ? projects.filter(
    //         (project) =>
    //             project.projectCategoryCode === selectedCategoryCode
    //     )
    //     : projects;

    const selectedCategory = projectCategories.find(
        (cat) => String(cat.id) === String(projectCategoryId)
    );

    const selectedCategoryCode = selectedCategory?.categoryCode;

    const filteredProjects = projectCategoryId
        ? projects.filter((project) => {

            // Super Admin / Data Admin
            if (project.projectCategoryId) {
                return (
                    String(project.projectCategoryId) ===
                    String(projectCategoryId)
                );
            }

            // Employee
            return (
                project.projectCategoryCode ===
                selectedCategoryCode
            );

        })
        : projects;





    const showMessage = (text, type = "error") => {
        setMessage(text);
        setMsgType(type);
    };

    const loadDropdowns = async () => {
        try {
            // const user = StorageService.loginData();

            // const [projectCategoryRes, projectRes, storeRes, locationRes] = await Promise.all([

            //     ProjectCategoryService.getAll(),
            //     ProjectService.getActive(companyId, user.employeeId,
            //         user.roleId),
            //     StoreService.getActive(),
            //     LocationService.getActive(),
            // ]);

            // setProjectCategories(projectCategoryRes?.data || projectCategoryRes || []);
            // setProjects(projectRes?.data || projectRes || []);
            // setStores(storeRes?.data || storeRes || []);
            // setLocations(locationRes?.data || locationRes || []);

            const user = StorageService.loginData();

            let projectRes;

            if (Number(user.roleId) === 1 || Number(user.roleId) === 2) {

                // Super Admin & Data Admin
                projectRes = await ProjectService.getActive(companyId);
                console.log("Super Admin Projects =", projectRes);


            } else {

                // Employee
                projectRes = await ProjectService.getAssignedProjects(
                    companyId,
                    user.employeeId
                );
                // console.log("Assigned Projects Data =", projectRes.data);
            }

            const [projectCategoryRes, storeRes, locationRes] =
                await Promise.all([
                    ProjectCategoryService.getAll(),
                    StoreService.getActive(),
                    LocationService.getActive(),
                ]);

            setProjectCategories(projectCategoryRes?.data || projectCategoryRes || []);

            let projectList = [];

            if (Number(user.roleId) === 1 || Number(user.roleId) === 2) {

                // Super Admin / Data Admin
                projectList = Array.isArray(projectRes)
                    ? projectRes
                    : (projectRes?.data || []);
            } else {

                // Employee
                projectList = projectRes?.data?.data || [];

            }

            setProjects(projectList);

            console.log("Projects =", projectList);
            console.log("First Project =", projectList[0]);

            setStores(storeRes?.data || storeRes || []);
            setLocations(locationRes?.data || locationRes || []);
        } catch (error) {
            console.error(error);
            setProjectCategories([]);
            setProjects([]);
            setStores([]);
            setLocations([]);
            showMessage("Failed to load filter dropdowns");
        }
    };

    const loadStoresByProject = async (projectId) => {
        if (!projectId) {
            setStores([]);
            return;
        }

        try {
            const res = await ProjectStoreService.getProjectStoreById(projectId);
            console.log("Project Store Response =", res);
            console.log("Stores =", res.data);
            setStores(res?.data || res || []);
        } catch (err) {
            console.error("Store load error", err);
            setStores([]);
        }
    };

    const loadLocationsByProjectAndStore = async (projectId, storeId) => {
        if (!projectId || !storeId) {
            setLocations([]);
            return;
        }

        try {
            const res = await ProjectLocationService.getByProjectAndStore(projectId, storeId);
            setLocations(res?.data || []);
        } catch (err) {
            console.error("Location load error", err);
            setLocations([]);
        }
    };

    const loadReport = async (pageNumber = page) => {

        if (projectCategoryId || projectId) {
            if (!projectCategoryId) {
                showMessage("Project Category is required");
                return;
            }

            if (!projectId) {
                showMessage("Project Name is required");
                return;
            }
        }

        if ((projectCategoryId || projectId) && (!startDate || !endDate)) {
            showMessage("Start Date and End Date are required");
            return;
        }

        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            showMessage("Start Date should be less than or equal to End Date");
            return;
        }

        setLoading(true);
        try {
            setReports([]);
            setPage(1);
            const user = StorageService.loginData();
            const res =
                await MaterialReconciliationReportService.getReport({
                    companyId: companyId || undefined,
                    employeeId: user.employeeId,
                    roleId: user.roleId,
                    projectCategoryId: projectCategoryId || undefined,
                    projectId: projectId || undefined,
                    storeId: storeId || undefined,
                    locationId: locationId || undefined,
                    startDate: startDate || undefined,
                    endDate: endDate || undefined,

                    // ✅ NEW
                    page: pageNumber,
                    limit: limit,
                });

            // ✅ IMPORTANT
            setReports(res?.data || []);
            setTotalPages(res?.pagination?.totalPages || 0);
            setTotalRecords(res?.pagination?.total || 0);
            setPage(pageNumber);

        } catch (error) {
            console.error(error);
            setReports([]);
            showMessage("Error fetching Material Reconciliation Report");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (companyId) {
            loadDropdowns();

            const today = new Date().toISOString().split("T")[0];
            setEndDate(today);

            // ✅ ADD THIS LINE
            loadReport();
        }
    }, [companyId]);

    const handleClearFilters = () => {
        setProjectCategoryId("");
        setProjectId("");
        setStoreId("");
        setLocationId("");
        setStartDate("");

        const today = new Date().toISOString().split("T")[0];
        setEndDate(today);

        // ✅ RESET PAGINATION
        setPage(1);
        setTotalPages(0);

        loadReport(1);
    };

    const getAllReportData = async () => {
        try {
            let allData = [];
            let currentPage = 1;
            let totalPages = 1;

            do {
                const user = StorageService.loginData();
                const res =
                    await MaterialReconciliationReportService.getReport({
                        companyId: companyId || undefined,
                        employeeId: user.employeeId,
                        roleId: user.roleId,
                        projectCategoryId: projectCategoryId || undefined,
                        projectId: projectId || undefined,
                        storeId: storeId || undefined,
                        locationId: locationId || undefined,
                        startDate: startDate || undefined,
                        endDate: endDate || undefined,
                        page: currentPage,
                        limit: 10
                    });

                const data = res?.data || [];
                const pagination = res?.pagination || {};

                allData = [...allData, ...data];

                totalPages = pagination.totalPages || 1;
                currentPage++;

            } while (currentPage <= totalPages);

            return allData;

        } catch (error) {
            console.error("PDF error:", error);
            return [];
        }
    };

    const exportExcel = async () => {
        if (!projectCategoryId) {
            showMessage("Project Category is required");
            return;
        }

        if (!projectId) {
            showMessage("Project Name is required");
            return;
        }
        const allData = await getAllReportData();

        if (!allData.length) {
            showMessage("No data to export");
            return;
        }
        const toNumber = (value) => {
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : 0;
        };
        const sortedData = [...allData].sort((a, b) => {
            const dateA = new Date(a.reportDate || 0).getTime();
            const dateB = new Date(b.reportDate || 0).getTime();
            return dateA - dateB;
        });

        const wb = XLSX.utils.book_new();
        const ws = {};
        ws["!merges"] = [];

        // Get filter labels
        let projectCategoryLabel = "All";
        if (projectCategoryId) {
            const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
            projectCategoryLabel = found?.categoryName || projectCategoryId;
        }

        let projectLabel = "All";
        if (projectId) {
            const found = projects.find(p => String(p.id) === String(projectId));
            projectLabel = found?.projectName || projectId;
        }

        let storeLabel = "All";
        if (storeId) {
            // const found = stores.find(s => String(s.id) === String(storeId));
            const found = stores.find(
                s => String(s.storeId) === String(storeId)
            );
            storeLabel = found?.storeName || storeId;
        }

        let locationLabel = "All";
        if (locationId) {
            const found = locations.find(l => String(l.id) === String(locationId));
            locationLabel = found?.locationName || locationId;
        }

        let row = 1;

        // STYLES
        const thin = { style: "thin" };
        const center = {
            horizontal: "center",
            vertical: "center",
            wrapText: true
        };

        // COMPANY NAME (Top Left)
        const companyName = activeCompany?.companyName || "";
        XLSX.utils.sheet_add_aoa(ws, [[companyName]], { origin: { r: 0, c: 0 } });

        // REPORT DATE (Top Right)
        XLSX.utils.sheet_add_aoa(
            ws,
            [[`Report Date: ${utility.formatExportDateTime(new Date())}`]],
            { origin: { r: 0, c: 8 } } // adjust column for right alignment
        );

        // STYLE COMPANY NAME
        ws[XLSX.utils.encode_cell({ r: 0, c: 0 })].s = {
            font: { bold: true, sz: 12 }
        };

        // STYLE REPORT DATE
        ws[XLSX.utils.encode_cell({ r: 0, c: 8 })].s = {
            alignment: { horizontal: "right" },
            font: { bold: true, sz: 11 }
        };
        // TITLE
        XLSX.utils.sheet_add_aoa(ws, [["Material Reconciliation Report"]], { origin: { r: row, c: 0 } });
        ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 10 } });
        const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
        ws[titleCell].s = {
            font: { bold: true, sz: 16 },
            alignment: center,
            border: {
                top: thin,
                bottom: thin,
                left: thin,
                right: thin
            }
        };
        row += 2;

        // FILTER INFO
        XLSX.utils.sheet_add_aoa(ws, [
            ["Project Category:", projectCategoryLabel, "Project:", projectLabel],
            ["Store:", storeLabel, "Location:", locationLabel],
            ["Start Date:", startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", "End Date:", endDate ? utility.formatDateDDMMMYYYY(endDate) : "-"],
        ], { origin: { r: row, c: 0 } });

        const filterLabelStyle = {
            font: { bold: true, sz: 10 },
            alignment: { horizontal: "left", vertical: "center" },
            border: { top: thin, bottom: thin, left: thin, right: thin }
        };

        const filterValueStyle = {
            font: { sz: 10 },
            alignment: { horizontal: "left", vertical: "center" },
            border: { top: thin, bottom: thin, left: thin, right: thin }
        };

        const boldLabelColumns = [0, 2];
        for (let i = 0; i < 3; i++) {
            for (let c = 0; c < 4; c++) {
                const cell = XLSX.utils.encode_cell({ r: row + i, c });
                if (!ws[cell]) continue;
                ws[cell].s = boldLabelColumns.includes(c) ? filterLabelStyle : filterValueStyle;
            }
        }
        row += 4;

        // TABLE HEADER
        const headerRowIndex = row;
        XLSX.utils.sheet_add_aoa(ws, [
            [
                "Date",
                "Store",
                "Location",
                "Item",
                "Outward",
                "",
                "Return",
                "",
                "",
                "Received Qty",
                "Previous Site Balance",
                "Total Qty",
                "DPR",
                "",
                "",
                "",
                "Site Balance",
                "Work Status"
            ],
            [
                "",
                "",
                "",
                "",
                "Voucher No",
                "Issued Qty",
                "Voucher No",
                "Return Qty",
                "Damage Qty",
                "",
                "",
                "",
                "Consumption Qty",
                "Returned Qty",
                "Damaged Qty",
                "Lost Qty",
                "",
                ""
            ]
        ], {
            origin: { r: row, c: 0 }
        });

        ws["!merges"].push(
            { s: { r: row, c: 0 }, e: { r: row + 1, c: 0 } },
            { s: { r: row, c: 1 }, e: { r: row + 1, c: 1 } },
            { s: { r: row, c: 2 }, e: { r: row + 1, c: 2 } },
            { s: { r: row, c: 3 }, e: { r: row + 1, c: 3 } },

            { s: { r: row, c: 4 }, e: { r: row, c: 5 } },
            { s: { r: row, c: 6 }, e: { r: row, c: 8 } },

            { s: { r: row, c: 9 }, e: { r: row + 1, c: 9 } },
            { s: { r: row, c: 10 }, e: { r: row + 1, c: 10 } },
            { s: { r: row, c: 11 }, e: { r: row + 1, c: 11 } },

            { s: { r: row, c: 12 }, e: { r: row, c: 15 } },

            { s: { r: row, c: 16 }, e: { r: row + 1, c: 16 } },
            { s: { r: row, c: 17 }, e: { r: row + 1, c: 17 } }
        );

        for (let r = row; r <= row + 1; r++) {

            for (let c = 0; c <= 17; c++) {

                const cell = XLSX.utils.encode_cell({ r, c });

                if (!ws[cell]) continue;

                ws[cell].s = {
                    font: {
                        bold: true,
                        sz: 10
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true
                    },
                    border: {
                        top: thin,
                        bottom: thin,
                        left: thin,
                        right: thin
                    }
                };
            }
        }


        row += 2;

        // TABLE DATA
        sortedData.forEach((reportRow) => {
            const rowData = [
                reportRow.reportDate,
                reportRow.storeName,
                reportRow.locationName,
                reportRow.itemCode,
                reportRow.vocherNo,
                toNumber(reportRow.issuedQty),
                reportRow.returnVoucherNo,
                toNumber(reportRow.returnQty),
                toNumber(reportRow.returnDamageQty),
                toNumber(reportRow.receivedQty),
                toNumber(reportRow.previousSiteBalance),
                toNumber(reportRow.totalQty),
                toNumber(reportRow.consumptionQty),
                toNumber(reportRow.returnedQty),
                toNumber(reportRow.damagedQty),
                toNumber(reportRow.lostQty),
                toNumber(reportRow.siteBalance),
                reportRow.workStatus
            ];

            XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });

            rowData.forEach((_, colIndex) => {

                const cell = XLSX.utils.encode_cell({
                    r: row,
                    c: colIndex
                });

                if (!ws[cell]) return;

                const isNum = [5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(colIndex);
                ws[cell].s = {
                    alignment: {
                        horizontal: isNum ? "right" : colIndex === 0 ? "center" : "left",
                        vertical: "center"
                    },
                    border: {
                        top: thin,
                        bottom: thin,
                        left: thin,
                        right: thin
                    }
                };

                if (isNum) {
                    ws[cell].t = "n";
                    ws[cell].v = toNumber(ws[cell].v);
                    ws[cell].z = "#,##0.000";
                }

                if (colIndex === 0 && ws[cell]?.v) {
                    const excelSerial = utility.convertDateToExcelSerial(ws[cell].v);
                    if (excelSerial) {
                        ws[cell].v = excelSerial;
                        ws[cell].t = "n";
                        ws[cell].z = "dd-mm-yyyy";
                    }
                }

            });

            row++;
        });

        // TOTALS ROW
        const totalIssuedQty = sortedData.reduce((sum, item) => sum + toNumber(item.issuedQty), 0);
        const totalReturnQty = sortedData.reduce((sum, item) => sum + toNumber(item.returnQty), 0);
        const totalReturnDamageQty = sortedData.reduce((sum, item) => sum + toNumber(item.returnDamageQty), 0);
        const totalReceivedQty = sortedData.reduce((sum, item) => sum + toNumber(item.receivedQty), 0);
        const totalPreviousSiteBalance = sortedData.reduce((sum, item) => sum + toNumber(item.previousSiteBalance), 0);
        const totalTotalQty = sortedData.reduce((sum, item) => sum + toNumber(item.totalQty), 0);
        const totalConsumptionQty = sortedData.reduce((sum, item) => sum + toNumber(item.consumptionQty), 0);
        const totalReturnedQty = sortedData.reduce((sum, item) => sum + toNumber(item.returnedQty), 0);
        const totalDamagedQty = sortedData.reduce((sum, item) => sum + toNumber(item.damagedQty), 0);
        const totalLostQty = sortedData.reduce((sum, item) => sum + toNumber(item.lostQty), 0);
        const totalSiteBalance = sortedData.reduce((sum, item) => sum + toNumber(item.siteBalance), 0);

        const totalsRow = [
            "",
            "",
            "",
            "Total:",
            "",
            totalIssuedQty,
            "",
            totalReturnQty,
            totalReturnDamageQty,
            totalReceivedQty,
            totalPreviousSiteBalance,
            totalTotalQty,
            totalConsumptionQty,
            totalReturnedQty,
            totalDamagedQty,
            totalLostQty,
            totalSiteBalance,
            ""
        ];

        XLSX.utils.sheet_add_aoa(ws, [totalsRow], { origin: { r: row, c: 0 } });
        totalsRow.forEach((_, colIndex) => {
            const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
            if (!ws[cell]) return;
            const isNum = [5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(colIndex);
            ws[cell].s = {
                font: { bold: true, sz: 10 },
                alignment: isNum
                    ? { horizontal: "right", vertical: "center" }
                    : colIndex === 3
                    ? { horizontal: "right", vertical: "center" }
                    : { horizontal: "center", vertical: "center" },
                border: { top: thin, bottom: thin, left: thin, right: thin }
            };
            if (isNum) {
                ws[cell].t = "n";
                ws[cell].z = "#,##0.000";
            }
        });
        row++;

        ws["!autofilter"] = {
            ref: XLSX.utils.encode_range({
                s: { r: headerRowIndex, c: 0 },
                e: { r: row - 1, c: 17 }
            })
        };

        // Set column widths
        ws["!cols"] = [
            { wch: 16 }, // Date
            { wch: 20 }, // Store
            { wch: 20 }, // Location
            { wch: 40 }, // Item
            { wch: 48 }, // Outward Voucher
            { wch: 12 }, // Issued Qty
            { wch: 48 }, // Return Voucher
            { wch: 12 }, // Return Qty
            { wch: 12 }, // Return Damage Qty
            { wch: 12 }, // Received Qty
            { wch: 15 }, // Previous Site Balance
            { wch: 12 }, // Total Qty
            { wch: 15 }, // Consumption Qty
            { wch: 12 }, // Returned Qty
            { wch: 12 }, // Damaged Qty
            { wch: 12 }, // Lost Qty
            { wch: 15 },
            { wch: 15 }
        ];

        XLSX.utils.book_append_sheet(wb, ws, "Material Reconciliation Report");
        // XLSX.writeFile(wb, "Material Reconciliation Report.xlsx");
        const projectCategoryName =
            projectCategories.find(
                x => String(x.id) === String(projectCategoryId)
            )?.categoryName || "All";

        const projectName =
            projects.find(
                x => String(x.id || x.projectId) === String(projectId)
            )?.projectName || "All";

        const fileName =
            `MaterialReconciliationRPT_${projectCategoryName}_${projectName}_${utility
                .formatDateDMY(new Date())
                .replace(/\//g, "-")}`;

        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const exportPdf = async () => {
        if (!projectCategoryId) {
            showMessage("Project Category is required");
            return;
        }

        if (!projectId) {
            showMessage("Project Name is required");
            return;
        }
        const allData = await getAllReportData();

        if (!allData.length) {
            showMessage("No data to export");
            return;
        }


        // Get filter labels
        let projectCategoryLabel = "All";
        if (projectCategoryId) {
            const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
            projectCategoryLabel = found?.categoryName || projectCategoryId;
        }

        let projectLabel = "All";
        if (projectId) {
            const found = projects.find(p => String(p.id) === String(projectId));
            projectLabel = found?.projectName || projectId;
        }

        let storeLabel = "All";
        if (storeId) {
            const found = stores.find(s => String(s.id) === String(storeId));
            storeLabel = found?.storeName || storeId;
        }

        let locationLabel = "All";
        if (locationId) {
            const found = locations.find(l => String(l.id) === String(locationId));
            locationLabel = found?.locationName || locationId;
        }

        const doc = new jsPDF("landscape", "mm", "a2");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        let yPosition = 18;

        const companyName = activeCompany?.companyName || "";




        // Company Name
        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        // const companyNameWidth = doc.getTextWidth(companyName);
        // const logoX = 14 + (companyNameWidth - 9) / 2;

        // await addPdfLogo(doc, logo, logoX, 10, 9, 15);
        // doc.text(companyName, 14, 31);

        // // Report Date (RIGHT SIDE)
        // const reportDate = utility.formatExportDateTime(new Date());

        // doc.setFontSize(10);

        // doc.setFont(undefined, "bold");
        // doc.text("Report Date:", pageWidth - 70, 15);

        // doc.setFont(undefined, "normal");
        // doc.text(reportDate, pageWidth - 14, 15, {
        //     align: "right"
        // });
        // const title = "Material Reconciliation Report";

        // doc.setFontSize(18);
        // doc.setFont(undefined, "bold");

        // const textWidth = doc.getTextWidth(title);
        // const centerX = (pageWidth - textWidth) / 2;

        // doc.text(title, centerX, 25);

        // doc.setLineWidth(0.3);
        // doc.line(centerX, 27, centerX + textWidth, 27);

        // Logo
        // Logo
        // await addPdfLogo(doc, logo, 14, 8, 10, 15);

        // Report Date (same line as logo)
        const reportDate = utility.formatExportDateTime(new Date());

        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text("Report Date:", pageWidth - 84, 15);

        doc.setFont(undefined, "normal");
        doc.text(reportDate, pageWidth - 14, 15, {
            align: "right"
        });

        // Company Name (below logo)
        const logoX = 25;
        const logoWidth = 10;

        await addPdfLogo(doc, logo, logoX, 8, logoWidth, 15);

        // Company Name centered below logo
        doc.setFontSize(11);
        doc.setFont(undefined, "bold");

        const companyWidth = doc.getTextWidth(companyName);
        const companyX = logoX + (logoWidth / 2) - (companyWidth / 2);

        doc.text(companyName, companyX, 28);

        // Report Title
        const title = "Material Reconciliation Report";

        doc.setFontSize(18);
        doc.setFont(undefined, "bold");

        const textWidth = doc.getTextWidth(title);
        const centerX = (pageWidth - textWidth) / 2;

        doc.text(title, centerX, 38);

        doc.setLineWidth(0.3);
        doc.line(centerX, 40, centerX + textWidth, 40);

        yPosition = 55;

        // ✅ START CONTENT FROM HERE
        // yPosition = 45;


        doc.setFontSize(14);
        doc.setFont(undefined, "bold");


        // ---- CENTER ALIGN ----
        let xLeft = 14;
        let xRight = 115;
        let yHeader = yPosition;
        doc.text("Project Category:", xLeft, yHeader);
        doc.setFont(undefined, "normal");
        doc.text(String(projectCategoryLabel), xLeft + 45, yHeader);

        doc.setFont(undefined, "bold");
        doc.text("Project:", xLeft, yHeader + 10);
        doc.setFont(undefined, "normal");
        doc.text(String(projectLabel), xLeft + 45, yHeader + 10);

        doc.setFont(undefined, "bold");
        doc.text("Store:", xLeft, yHeader + 18);
        doc.setFont(undefined, "normal");
        doc.text(String(storeLabel), xLeft + 45, yHeader + 18);

        // Right column
        // let xRight = pageWidth / 2;
        doc.setFont(undefined, "bold");
        doc.text("Location:", xRight, yHeader);
        doc.setFont(undefined, "normal");
        doc.text(String(locationLabel), xRight + 35, yHeader);

        doc.setFont(undefined, "bold");
        doc.text("Start Date:", xRight, yHeader + 10);
        doc.setFont(undefined, "normal");
        doc.text(startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", xRight + 35, yHeader + 10);

        doc.setFont(undefined, "bold");
        doc.text("End Date:", xRight, yHeader + 18);
        doc.setFont(undefined, "normal");
        doc.text(endDate ? utility.formatDateDDMMMYYYY(endDate) : "-", xRight + 35, yHeader + 18);

        yPosition += 35;

        const sortedData = [...allData].sort((a, b) => {
            const dateA = new Date(a.reportDate || 0).getTime();
            const dateB = new Date(b.reportDate || 0).getTime();
            return dateA - dateB;
        });

        // Table
        const body = sortedData.map((row, index) => [

            index + 1,

            utility.formatDateDDMMMYYYY(row.reportDate),

            row.storeName,

            row.locationName,

            row.itemCode,

            row.vocherNo,

            row.issuedQty,

            row.returnVoucherNo,

            row.returnQty,



            row.returnDamageQty,

            row.receivedQty,

            row.previousSiteBalance,

            row.totalQty,

            row.consumptionQty,

            row.returnedQty,

            row.damagedQty,

            row.lostQty,

            row.siteBalance,

            row.workStatus

        ]);
        const totalQuantity = sortedData.reduce((sum, row) => {
            return sum + Number(row.siteBalance || 0);
        }, 0);


        autoTable(doc, {
            startY: yPosition,
            head: [
                [
                    { content: "S.No", rowSpan: 2 },
                    { content: "Date", rowSpan: 2 },
                    { content: "Store", rowSpan: 2 },
                    { content: "Location", rowSpan: 2 },
                    { content: "Item", rowSpan: 2 },

                    { content: "Outward", colSpan: 2 },

                    { content: "Return", colSpan: 3 },

                    { content: "Received Qty", rowSpan: 2 },
                    { content: "Previous Site Balance", rowSpan: 2 },
                    { content: "Total Qty", rowSpan: 2 },

                    { content: "AS Per DPR", colSpan: 4 },

                    { content: "Site Balance", rowSpan: 2 },
                    { content: "Work Status", rowSpan: 2 }
                ],

                [
                    "Voucher No",
                    "Issued Qty",

                    "Voucher No",
                    "Return Qty",
                    "Damage Qty",

                    "Consumption Qty",
                    "Returned Qty",
                    "Damaged Qty",
                    "Lost Qty"
                ]
            ],

            // columnStyles: {
            //     5: { cellWidth: 18 },
            //     6: { cellWidth: 15 },

            //     7: { cellWidth: 18 },
            //     8: { cellWidth: 15 },
            //     9: { cellWidth: 15 },

            //     13: { cellWidth: 15 },
            //     14: { cellWidth: 15 },
            //     15: { cellWidth: 15 },
            //     16: { cellWidth: 15 }
            // },

            columnStyles: {
                // Outward
                0: { cellWidth: 15, halign: "right" },    // S.No
                1: { cellWidth: 25, halign: "center" },   // Date
                2: { cellWidth: 44, halign: "left" },     // Store
                3: { cellWidth: 44, halign: "left" },     // Location
                4: { cellWidth: 50, halign: "left" },     // Item

                5: { cellWidth: 54, halign: "left" },     // Outward Voucher No
                6: { cellWidth: 24, halign: "right" },    // Issued Qty

                // Return
                7: { cellWidth: 54, halign: "left" },     // Return Voucher No
                8: { cellWidth: 24, halign: "right" },    // Return Qty
                9: { cellWidth: 24, halign: "right" },    // Damage Qty

                // Reduce these widths
                10: { cellWidth: 24, halign: "right" },   // Received Qty
                11: { cellWidth: 24, halign: "right" },   // Previous Site Balance
                12: { cellWidth: 24, halign: "right" },   // Total Qty

                // DPR
                13: { cellWidth: 24, halign: "right" },   // Consumption Qty
                14: { cellWidth: 24, halign: "right" },   // Returned Qty
                15: { cellWidth: 24, halign: "right" },   // Damaged Qty
                16: { cellWidth: 24, halign: "right" },   // Lost Qty

                17: { cellWidth: 22, halign: "right" },   // Site Balance
                18: { cellWidth: 26, halign: "left" }    // Work Status
            },

            headStyles: {
                fillColor: [230, 230, 230],
                textColor: [0, 0, 0],
                fontStyle: "bold",
                FontSize: 14,
                halign: "center",
                valign: "middle"
            },

            didParseCell: function (data) {

                if (data.section === "head") {

                    data.cell.styles.halign = "center";
                    data.cell.styles.valign = "middle";

                }

            },

            body,

            foot: [[
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "Total",
                totalQuantity.toFixed(3)
            ]],

            showFoot: "lastPage",

            theme: "grid",

            styles: {
                fontSize: 11,
                lineColor: [0, 0, 0],
                lineWidth: 0.15,
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0]
            },

            alternateRowStyles: {
                fillColor: [255, 255, 255]
            },

            headStyles: {
                fillColor: [230, 230, 230],
                textColor: [0, 0, 0],
                fontStyle: "bold"
            },

            footStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                fontStyle: "bold"
            },

            margin: {
                top: 50,
                left: 14,
                right: 14,
                bottom: 25
            },

            didDrawPage: function (data) {

                if (data.pageNumber === 1) return;

                const companyNameWidth =
                    doc.getTextWidth(companyName);

                // const logoX =
                //     14 + (companyNameWidth - 9) / 2;

                // doc.addImage(
                //     logo,
                //     "PNG",
                //     logoX,
                //     10,
                //     9,
                //     15
                // );

                // doc.setFont(undefined, "bold");
                // doc.setFontSize(11);

                // doc.text(
                //     companyName,
                //     14,
                //     31
                // );



                // const reportDate = utility.formatExportDateTime(new Date());

                // doc.setFontSize(10);

                // doc.setFont(undefined, "bold");
                // doc.text("Report Date:", pageWidth - 70, 15);

                // doc.setFont(undefined, "normal");
                // doc.text(reportDate, pageWidth - 14, 15, {
                //     align: "right"
                // });

                // const title = "Material Reconciliation Report";

                // doc.setFontSize(18);

                // const textWidth =
                //     doc.getTextWidth(title);

                // const centerX =
                //     (pageWidth - textWidth) / 2;

                // doc.text(
                //     title,
                //     centerX,
                //     25
                // );

                // doc.setLineWidth(0.3);

                // doc.line(
                //     centerX,
                //     27,
                //     centerX + textWidth,
                //     27
                // );

                // doc.addImage(logo, "PNG", 14, 8, 10, 15);

                // Report Date
                const reportDate = utility.formatExportDateTime(new Date());

                doc.setFontSize(10);
                doc.setFont(undefined, "bold");
                doc.text("Report Date:", pageWidth - 70, 15);

                doc.setFont(undefined, "normal");
                doc.text(reportDate, pageWidth - 14, 15, {
                    align: "right"
                });

                // Company Name (below logo)
                // doc.setFontSize(11);
                // doc.setFont(undefined, "bold");
                // doc.text(companyName, 14, 28);

                const logoX = 25;
                const logoWidth = 10;

                doc.addImage(logo, "PNG", logoX, 8, logoWidth, 15);

                // Company Name centered below logo
                doc.setFontSize(11);
                doc.setFont(undefined, "bold");

                const companyWidth = doc.getTextWidth(companyName);
                const companyX = logoX + (logoWidth / 2) - (companyWidth / 2);

                doc.text(companyName, companyX, 28);

                // Report Title
                const title = "Material Reconciliation Report";

                doc.setFontSize(18);
                doc.setFont(undefined, "bold");

                const textWidth = doc.getTextWidth(title);
                const centerX = (pageWidth - textWidth) / 2;

                doc.text(title, centerX, 38);

                doc.setLineWidth(0.3);
                doc.line(centerX, 40, centerX + textWidth, 40);

                // Repeat filters also

                doc.setFontSize(9);
            }
        });

        const pageCount = doc.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);

            if (i === pageCount) {
                doc.setFont(undefined, "bold");
                doc.setFontSize(8);
                const footerTop = pageHeight - 20;
                doc.text("Prepared By", 25, footerTop);
                doc.text("Checked By", pageWidth / 2, footerTop, { align: "center" });
                doc.text("Approved By", pageWidth - 25, footerTop, { align: "right" });
            }

            doc.setFontSize(9);
            doc.setFont(undefined, "normal");

            doc.text(
                `Page ${i} of ${pageCount}`,
                pageWidth / 2,
                pageHeight - 10,
                { align: "center" }
            );
        }

        // doc.save("Material Reconciliation Report.pdf");
        const projectCategoryName =
            projectCategories.find(
                x => String(x.id) === String(projectCategoryId)
            )?.categoryName || "All";

        const projectName =
            projects.find(
                x => String(x.id || x.projectId) === String(projectId)
            )?.projectName || "All";

        const fileName =
            `MaterialReconciliationRPT_${projectCategoryName}_${projectName}_${utility
                .formatDateDMY(new Date())
                .replace(/\//g, "-")}`;

        doc.save(`${fileName}.pdf`);
    };

    return (
        <>
            <Breadcrumb pageTitle="Material Reconciliation Report" secondTitle="Reports" />
            <MessageDialog
                message={message}
                type={msgType}
                setMessage={setMessage}
                setMsgType={setMsgType}
            />

            <div className="card p-4 bg-white shadow-sm">
                <div className="row g-3 mb-3">
                    <div className="col-md-3">
                        <label className="form-label">Project Category <span className="text-danger">*</span></label>
                        <select
                            className="form-select"
                            value={projectCategoryId}
                            onChange={(e) => {
                                setProjectCategoryId(e.target.value);
                                setProjectId("");
                                setStoreId("");
                                setLocationId("");
                                setStartDate("");
                            }}
                        >
                            <option value="">Select Project Category</option>
                            {projectCategories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.categoryName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Project Name <span className="text-danger">*</span></label>

                        <select
                            className="form-select"
                            value={projectId}
                            onChange={(e) => {
                                const selectedProjectId = e.target.value;

                                setProjectId(selectedProjectId);
                                setStoreId("");
                                setLocationId("");

                                loadStoresByProject(selectedProjectId);   // ✅ ADD THIS

                                if (!selectedProjectId) {
                                    setStartDate("");
                                    return;
                                }

                                const selectedProject = projects.find(
                                    (p) => String(p.id || p.projectId) === String(selectedProjectId)
                                );

                                if (selectedProject?.projectStartDate) {
                                    const formattedDate = new Date(selectedProject.projectStartDate)
                                        .toISOString()
                                        .split("T")[0];

                                    setStartDate(formattedDate);
                                } else {
                                    setStartDate("");
                                }
                            }}
                            disabled={!projectCategoryId}
                        >
                            <option value="">Select Project Name</option>


                            {filteredProjects.map((project) => (
                                <option
                                    key={project.projectId || project.id}
                                    value={project.projectId || project.id}
                                >
                                    {project.projectName}
                                </option>
                            ))}

                        </select>

                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Store</label>

                        <select
                            className="form-select"
                            value={storeId}
                            onChange={(e) => {
                                const selectedStoreId = e.target.value;

                                setStoreId(selectedStoreId);
                                setLocationId("");

                                loadLocationsByProjectAndStore(projectId, selectedStoreId); // ✅ ADD
                            }}
                            disabled={!projectId}
                        >
                            <option value="">All</option>

                            {stores.map((store) => (
                                <option
                                    key={store.storeId}
                                    value={store.storeId}
                                >
                                    {store.storeName}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Location</label>

                        <select
                            className="form-select"
                            value={locationId}
                            onChange={(e) => setLocationId(e.target.value)}
                            disabled={!storeId}
                        >
                            <option value="">All</option>

                            {locations.map((location) => (
                                <option key={location.id} value={location.id}>
                                    {location.locationName}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Start Date <span className="text-danger">*</span></label>
                        <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">End Date <span className="text-danger">*</span></label>
                        <input
                            type="date"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mb-3 d-flex justify-content-end align-items-center">

                    <div className="d-flex gap-2">

                        <button className="btn btn-secondary" onClick={handleClearFilters}>
                            <i className="ti ti-refresh me-1"></i>
                            Clear
                        </button>

                        <button className="btn btn-primary" onClick={() => loadReport(1)} disabled={loading}>
                            <i className="ti ti-search me-1"></i>
                            {loading ? "Searching..." : "View Report"}
                        </button>
                    </div>
                </div>
                <hr />
                <div className="mb-3 d-flex justify-content-end align-items-center">
                    <div className="d-flex gap-2">
                        <button className="btn btn-success" onClick={exportPdf} disabled={loading}>
                            <i className="ti ti-file-type-pdf me-1"></i>
                            Export PDF
                        </button>

                        <button className="btn btn-success" onClick={exportExcel} disabled={loading}>
                            <i className="ti ti-file-spreadsheet me-1"></i>
                            Export Excel
                        </button>
                    </div>


                </div>

                <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                        <thead>
                            <tr>
                                <th rowSpan="2" className="text-center align-middle">S.No</th>
                                <th rowSpan="2" className="text-center align-middle" >Date</th>
                                <th rowSpan="2" className="text-center align-middle">Store</th>
                                <th rowSpan="2" className="text-center align-middle">Location</th>
                                <th rowSpan="2" className="text-center align-middle">Item</th>

                                <th colSpan="2" className="text-center align-middle">Outward</th>

                                <th colSpan="3" className="text-center align-middle">Return</th>

                                <th rowSpan="2" className="text-center align-middle">Received Qty</th>
                                <th rowSpan="2" className="text-center align-middle">Previous Site Balance</th>
                                <th rowSpan="2" className="text-center align-middle">Total Qty</th>

                                <th colSpan="4" className="text-center align-middle"> DPR</th>

                                <th rowSpan="2" className="text-center align-middle">Site Balance</th>
                                <th rowSpan="2" className="text-center align-middle">Work Status</th>
                            </tr>

                            <tr>
                                <th className="text-center align-middle">Voucher No</th>
                                <th className="text-center align-middle">Issued Qty</th>

                                <th className="text-center align-middle">Voucher No</th>
                                <th className="text-center align-middle">Return Qty</th>
                                <th className="text-center align-middle">Damage Qty</th>

                                <th className="text-center align-middle">Consumption Qty</th>
                                <th className="text-center align-middle">Returned Qty</th>
                                <th className="text-center align-middle">Damaged Qty</th>
                                <th className="text-center align-middle">Lost Qty</th>
                            </tr>
                        </thead>
                        <tbody>

                            {loading ? (

                                <tr>
                                    <td colSpan="19" className="text-center">
                                        <div className="spinner-border text-primary" />
                                    </td>
                                </tr>

                            ) : reports.length === 0 ? (

                                <tr>
                                    <td colSpan="19" className="text-center">
                                        No data found
                                    </td>
                                </tr>

                            ) : (

                                reports.map((row, index) => (

                                    <tr key={index}>

                                        <td>
                                            {(page - 1) * limit + index + 1}
                                        </td>

                                        <td>
                                            {utility.formatDateDDMMMYYYY(
                                                row.reportDate
                                            )}
                                        </td>

                                        <td>{row.storeName}</td>

                                        <td>{row.locationName}</td>

                                        <td>{row.itemCode}</td>

                                        <td>{row.vocherNo}</td>

                                        <td>{row.issuedQty}</td>

                                        <td>{row.returnVoucherNo}</td>

                                        <td>{row.returnQty}</td>

                                        <td>{row.returnDamageQty}</td>

                                        <td>{row.receivedQty}</td>

                                        <td>{row.previousSiteBalance}</td>

                                        <td>{row.totalQty}</td>

                                        <td>{row.consumptionQty}</td>

                                        <td>{row.returnedQty}</td>

                                        <td>{row.damagedQty}</td>

                                        <td>{row.lostQty}</td>

                                        <td>{row.siteBalance}</td>
                                        <td>{row.workStatus}</td>

                                    </tr>

                                ))

                            )}

                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-3">

                            {/* TOTAL RECORDS */}
                            <div>
                                Total Records: <strong>{totalRecords}</strong>
                            </div>

                            {/* PAGINATION BUTTONS */}
                            <div className="d-flex gap-2">

                                <button
                                    className="btn btn-sm btn-secondary"
                                    disabled={page === 1}
                                    onClick={() => loadReport(page - 1)}
                                >
                                    Prev
                                </button>

                                {[...Array(totalPages)].map((_, i) => (
                                    <button
                                        key={i}
                                        className={`btn btn-sm ${page === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => loadReport(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    className="btn btn-sm btn-secondary"
                                    disabled={page === totalPages}
                                    onClick={() => loadReport(page + 1)}
                                >
                                    Next
                                </button>

                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
